<script setup>
import { useSocials } from './config'
import { useComingSoonMessage } from '~/components/home/utils/message'

const props = defineProps({
  className: {
    type: String,
    default: '',
  },
})

const socials = useSocials()
const showComingSoonMessage = useComingSoonMessage()
</script>

<template>
  <div class="flex items-center gap-4" :class="[className]">
    <template v-for="i, index in socials" :key="index">
      <a
        :href="i.href || 'javascript:void(0)'"
        rel="nofollow"
        class="inline-flex items-center justify-center w-6 h-6 rounded-full"
        @click="!i.href && showComingSoonMessage('social')"
      >
        <component
          :is="i.icon"
          class="w-[24px] h-[24px] bg-btnSecondary text-textPrimary rounded-full hover:bg-btnSecondaryHover"
          :class="i.class"
        />
      </a>
    </template>
  </div>
</template>

<style scoped>
.social-icon-telegram :deep(path),
.social-icon-medium :deep(path),
.social-icon-linkedin :deep(path),
.social-icon-facebook :deep(path),
.social-icon-tiktok :deep(path) {
  fill: currentColor;
}

.social-icon-x :deep(circle),
.social-icon-facebook :deep(path:first-child),
.social-icon-telegram :deep(path:first-child) {
  fill: var(--btnSecondary);
}
</style>
